
export default () => {
    if (document.querySelector('.page-template-page-testimonials') !== null) {
        if(nobox.currentLang == "en"){
            var loadmoreTxt = "Load more";
            var nomoreTxt = "No more posts";
            var loadingTxt = "Loading...";
            var nomorepostsTxt = "No posts to be shown";
        } else {
            var loadmoreTxt = "Ladda fler";
            var nomoreTxt = "Inga fler poster att visa";
            var loadingTxt = "Laddar...";
            var nomorepostsTxt = "Inga fler poster att visa";
        }

        const loadmoreBtn = document.querySelector('#loadMore');
        const postContainer = document.querySelector('.testimonialContainer');


        let dataLM = { //data load more
            action: 'nobox_load_more_testimonials',
            offset: 0,
            archive: window.location.href,
        };

        loadmoreBtn.addEventListener('click', (e) => {
            dataLM = { //data load more
                action: 'nobox_load_more_testimonials',
                offset: dataLM.offset,
                archive: window.location.href,
            };
            loadmoreBtn.innerHTML = loadingTxt;
            dataLM.offset += 5;

            $.post(
                nobox.ajaxUrl,
                dataLM,
                (data, response) => {
                    if (response === 'success') {
                        if (data.result.length > 0) {
                            data.result.forEach((post) => {
                                postContainer.innerHTML += post;
                            });
                            loadmoreBtn.innerHTML = loadmoreTxt;
                            addClickEvents();
                        } else {
                            dataLM.offset -= 5;
                            loadmoreBtn.innerHTML = nomoreTxt;
                            loadmoreBtn.classList.add("empty");
                        }
                    }
                }
            );
        });

        addClickEvents();
        function addClickEvents() {
            $('.testimonial').each(function(){
                var video = $(this).find('iframe');
                var src = $(this).find('iframe').attr('src');
                $(this).find('.title').hover(function(){
                    $(this).parent().siblings('.effect').addClass("active");
                }, function(){
                    $(this).parent().siblings('.effect').removeClass("active");
                });
                $(this).find('.thumbnail').click(function(){
                    $(this).remove();
                    video.attr('src', src + '?autoplay=1');
                });
                $(this).find('.thumbnailRemover').click(function(){
                    event.preventDefault();
                    $(this).parent().parent().parent().find('.thumbnail').remove();
                    video.attr('src', src + '?autoplay=1');
                });
            });
        }

    }
};


